import React from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import Layout from '../components/Layout/Layout';
import Seo from '../components/Seo/Seo';
import Join from '../components/Join/Join';
import COS_FOOTER_FIDELITE from '../images/COS_FOOTER_FIDELITE.jpg';

const Rejoindre = () => {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.RAZZLE_RECAPTCHA_SITE_KEY}
    >
      <Layout logo={COS_FOOTER_FIDELITE}>
        <Seo title="COS - Nous rejoindre" description="COS - Nous rejoindre" />
        <Join />
      </Layout>
    </GoogleReCaptchaProvider>
  );
};

export default Rejoindre;
